import { render, staticRenderFns } from "./ScreenShotDialog.vue?vue&type=template&id=96e1c990&scoped=true"
import script from "./ScreenShotDialog.vue?vue&type=script&lang=js"
export * from "./ScreenShotDialog.vue?vue&type=script&lang=js"
import style0 from "./ScreenShotDialog.vue?vue&type=style&index=0&id=96e1c990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e1c990",
  null
  
)

export default component.exports